<template>
  <div class="analysis__wrapper">
    <!-- Header -->
    <div class="analysis__header">
      <div class="analysis__container">
        <div class="analysis__partner__logo"></div>
      </div>
    </div>

    <!-- Contents -->
    <div class="analysis__contents">
      <div class="analysis__container">
        <div class="analysis__title">
          <p>사전교육 패키지 학습 종합 결과</p>
        </div>

        <div class="analysis__box__first">
          <div class="analysis__box__first__left">
            <div class="analysis__box__first__left__title">
              첫시도 성공 미션수
              <img
                class="analysis__box__first__left__title__icon"
                @click="showModal('analysis-alert-template', '첫시도 성공 미션수란?', '미션을 실행하여 실패하지 않고 한번에 성공한 미션의 수입니다.')"
                src="../assets/images/analysis/btn_question_mark.png"
              >
            </div>
            <div class="analysis__box__first__left__contents">
              <div class="analysis__box__first__left__contents__border"></div>
              <p class="analysis__box__first__left__contents__title1">순차 : {{frtSucMiCnt1}}/10</p>
              <div>
                <div
                  v-for="idx in 10"
                  :key="idx"
                  :class="[ idx <= frtSucMiCnt1 ? 'progress-bg-order' : 'progress-bg']"
                ></div>
              </div>
              <p class="analysis__box__first__left__contents__title2">반복 : {{frtSucMiCnt2}}/10</p>
              <div>
                <div
                  v-for="idx in 10"
                  :key="idx"
                  :class="[ idx <= frtSucMiCnt2 ? 'progress-bg-repeat' : 'progress-bg']"
                ></div>
              </div>
              <p class="analysis__box__first__left__contents__title3">선택 : {{frtSucMiCnt3}}/10</p>
              <div>
                <div
                  v-for="idx in 10"
                  :key="idx"
                  :class="[ idx <= frtSucMiCnt3 ? 'progress-bg-select' : 'progress-bg']"
                ></div>
              </div>
              <p class="analysis__box__first__left__contents__title4">변수 : {{frtSucMiCnt4}}/10</p>
              <div>
                <div
                  v-for="idx in 10"
                  :key="idx"
                  :class="[ idx <= frtSucMiCnt4 ? 'progress-bg-variable' : 'progress-bg']"
                ></div>
              </div>
            </div>
          </div>
          <div class="analysis__box__first__center">&nbsp;</div>
          <div class="analysis__box__first__right">
            <div class="analysis__box__first__right__title">
              블록사용 달성 미션수
              <img
                class="analysis__box__first__left__title__icon"
                @click="showModal('analysis-alert-template', '블록사용 달성 미션수', '미션별로 주어진 목표블록 개수에 맞추어 문제를 해결한 수입니다.')"
                src="../assets/images/analysis/btn_question_mark.png"
              >
            </div>
            <div class="analysis__box__first__left__contents">

              <div class="analysis__box__first__right__contents__border"></div>
              <p class="analysis__box__first__right__contents__title1">순차 : {{blkSucMiCnt1}}/10</p>
              <div class="analysis__box__first__right__contents__box1">
                <div>
                  <div
                    v-for="idx in 10"
                    :key="idx"
                    :class="[ idx <= blkSucMiCnt1 ? 'progress-bg-order' : 'progress-bg']"
                  ></div>
                </div>
              </div>
              <p class="analysis__box__first__right__contents__title2">반복 : {{blkSucMiCnt2}}/10</p>
              <div class="analysis__box__first__right__contents__box2">
                <div>
                  <div
                    v-for="idx in 10"
                    :key="idx"
                    :class="[ idx <= blkSucMiCnt2 ? 'progress-bg-repeat' : 'progress-bg']"
                  ></div>
                </div>
              </div>
              <p class="analysis__box__first__right__contents__title3">선택 : {{blkSucMiCnt3}}/10</p>
              <div class="analysis__box__first__right__contents__box3">
                <div>
                  <div
                    v-for="idx in 10"
                    :key="idx"
                    :class="[ idx <= blkSucMiCnt3 ? 'progress-bg-select' : 'progress-bg']"
                  ></div>
                </div>
              </div>
              <p class="analysis__box__first__right__contents__title4">변수 : {{blkSucMiCnt4}}/10</p>
              <div class="analysis__box__first__right__contents__box4">
                <div>
                  <div
                    v-for="idx in 10"
                    :key="idx"
                    :class="[ idx <= blkSucMiCnt4 ? 'progress-bg-variable' : 'progress-bg']"
                  ></div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="analysis__box__second">
          <div
            class="analysis__request__detail__btn"
            onclick="location.href='/codmos/analysis/detail'"
          >
            <div class="analysis__request__detail">학습결과 자세히 보기</div>
          </div>
          <div
            class="analysis__request__detail__btn__exit"
            onclick="location.href='/codmos/list'"
          >
            <div class="analysis__request__detail">닫기</div>
          </div>
        </div>
      </div>
    </div>

    <!-- Footer -->
    <div class="analysis__footer">
      <div class="analysis__container">
        <p>추천강좌</p>
        <div class="analysis__footer__contents">
          <div
            class="analysis__footer__contents__suggest1"
            @click="to(link1)"
          >
            <div :class="'analysis__footer__contents__suggest1__bg' + suggestType"></div>
            <div class="analysis__footer__contents__suggest1__divider"></div>
            <div class="analysis__footer__contents__suggest1__title">{{suggestTitle1}}</div>
          </div>
          <div
            class="analysis__footer__contents__suggest2"
            @click="to(link2)"
          >
            <div :class="'analysis__footer__contents__suggest2__bg' + suggestType"></div>
            <div class="analysis__footer__contents__suggest2__divider"></div>
            <div class="analysis__footer__contents__suggest2__title">{{suggestTitle2}}</div>
          </div>
          <div
            :class="[ suggestType === 3 ? 'analysis__footer__contents__suggest3__none' : 'analysis__footer__contents__suggest3']"
            @click="to(link3)"
          >
            <div :class="'analysis__footer__contents__suggest3__bg' + suggestType"></div>
            <div class="analysis__footer__contents__suggest3__divider"></div>
            <div class="analysis__footer__contents__suggest3__title">{{suggestTitle3}}</div>
          </div>
        </div>
      </div>
    </div>
    <component
      v-if="isShowModal"
      :is="modal"
      :title="modalTitle"
      :data="modalData"
      @close="isLoginPopup ? toLogin() : isShowModal = false"
      :userDevice="userDevice"
      :confirm="confirm"
    ></component>
  </div>
</template>
<script>
require('@fortawesome/fontawesome-free');
import { was } from '@/lib/axios';
import mobileDetect from 'mobile-detect'
import analysisAlertTemplate from './modal/AnalysisModal'


const BROWSER_TYPE = navigator.userAgent.toLowerCase();
let gaScript;
if (
  BROWSER_TYPE.indexOf('msie 10.0') > -1 // IE 10
  || BROWSER_TYPE.indexOf('msie 9.0') > -1 // IE 9
  || BROWSER_TYPE.indexOf('msie 8.0') > -1 // IE 8
  || BROWSER_TYPE.indexOf('msie 7.0') > -1 // IE 7
) gaScript = require('../../static/assets/js/utility/googleanalytics-ie10');
else gaScript = require('../../static/assets/js/utility/googleanalytics');

let cmpList;
if (window.NODE_ENV === 'production' && window.NODE_REL === 'release') {
  cmpList = {
    analysisAlertTemplate,
    gaScript
  };
} else {
  cmpList = {
    analysisAlertTemplate
  };
}
export default {
  name: "CodmosResult",
  components: cmpList,
  data () {
    return {
      percentage: 70,
      desc: [
      ],
      isShowModal: false,
      modalTitle: '',
      modal: '',
      modalData: null,
      isLoading: false,
      allClear: false,
      isLoginPopup: false,
      userDevice: 'pc',
      confirm: '',
      gradeTotal: 0,
      frtSucMiCnt1: 0,
      frtSucMiCnt2: 0,
      frtSucMiCnt3: 0,
      frtSucMiCnt4: 0,
      blkSucMiCnt1: 0,
      blkSucMiCnt2: 0,
      blkSucMiCnt3: 0,
      blkSucMiCnt4: 0,
      suggestTitle1: '',
      suggestTitle2: '',
      suggestTitle3: '',
      suggestType: 1,
      grade: '',
      link1: '',
      link2: '',
      link3: ''
    }
  },
  created () {
    const MD = new mobileDetect(window.navigator.userAgent);
    if (MD.tablet() !== null) this.userDevice = 'tablet';
    else if (MD.mobile() !== null) this.userDevice = 'mobile';

    // this.getUser()
    // this.getStudyAnalysis();
    this.checkSession();
  },
  mounted: function () {
    this.isLoading = false;

  },
  methods: {
    to (link) {
      //location.href = link
      //window.open(link, '_blank');
      window.top.location.href = link;
      //window.top.open(link, '_blank');
    },
    toLogin () {
      location.href = '/sso/loginView.do'
    },
    showModal (tpl, title, text) {
      if (this.isShowModal === true) return;
      this.modalTitle = title || '안내';
      this.modalData = text || '로그인 정보가 없습니다. 로그인후 이용해주세요.';
      this.modal = tpl || 'analysis-alert-template';
      this.isShowModal = true
    },
    sample (cb) {
      was
        .post(
          `${this.API_SERVER_URL}/manage/codmos/analysis`,
          { jsession_id: this.getCookie() }
        )
        .then(res => {
          try {
            console.log('[getStudyAnalysis] Return Code >>> ' + res.data.code);
            switch (res.data.code) {
              case '1000':
                {
                  document.cookie = 'userType=convert; path=/; expires=Thur, 31 Dec 2099 23:59:59 UTC;';
                  if (typeof cb === 'function') cb();
                } break;
              case '3000':
              case '2000':
              default:
                {
                  this.isLoginPopup = true;
                  this.showModal();
                } break;
            }
          } catch (err) {
            console.log('[getStudyAnalysis] Err >>> ' + err);
          }
        })
        .catch(e => {
          this.isLoginPopup = true;
          this.showModal();
          console.error(e)
        });
    },
    getStudyAnalysis () {
      // console.log(`[CodmosAnalysis] getStudyAnalysis called!`);
      const getCookie = this.getCookie('JSESSIONID');
      was
        .post(
          `${this.API_SERVER_URL}/manage/codmos/analysis`,
          { jsession_id: getCookie }
        )
        .then(res => {
          if (res.data.code !== '1000' || res.data.analysisInfo === undefined) {

          } else {
            let rtnInfo = res.data.analysisInfo;

            // 서버 수신 통계데이터 LocalStorage내 저장
            localStorage["analysisInfo"] = JSON.stringify(rtnInfo);

            this.frtSucMiCnt1 = rtnInfo.frtSucMiCnt1;
            this.frtSucMiCnt2 = rtnInfo.frtSucMiCnt2;
            this.frtSucMiCnt3 = rtnInfo.frtSucMiCnt3;
            this.frtSucMiCnt4 = rtnInfo.frtSucMiCnt4;
            this.blkSucMiCnt1 = rtnInfo.blkSucMiCnt1;
            this.blkSucMiCnt2 = rtnInfo.blkSucMiCnt2;
            this.blkSucMiCnt3 = rtnInfo.blkSucMiCnt3;
            this.blkSucMiCnt4 = rtnInfo.blkSucMiCnt4;
            this.gradeTotal = rtnInfo.gradeTotal;

            // 등급에 맞는 추천강좌 정보 업데이트
            if (this.gradeTotal < 60) {         // C 등급
              this.grade = 'c';
              this.suggestType = 3;
              this.suggestTitle1 = '티노와 함께하는 기초 프로그래밍(상)';
              this.suggestTitle2 = '티노와 함께하는 기초 프로그래밍(하)';
              this.suggestTitle3 = '';
              this.link1 = '/lrnng/alctcr/alctcrDetailView.do?alctcrSn=43';
              this.link2 = '/lrnng/alctcr/alctcrDetailView.do?alctcrSn=50';
              this.link3 = '/';
            } else if (this.gradeTotal < 80) {   // B 등급
              this.grade = 'b';
              this.suggestType = 2;
              this.suggestTitle1 = '뚜앙과 함께 떠나는 프로그래밍 여행(순차)';
              this.suggestTitle2 = '뚜앙과 함께 떠나는 프로그래밍 여행(선택)';
              this.suggestTitle3 = '뚜앙과 함께 떠나는 프로그래밍 여행(반복)';
              this.link1 = '/lrnng/alctcr/alctcrDetailView.do?alctcrSn=156';
              this.link2 = '/lrnng/alctcr/alctcrDetailView.do?alctcrSn=1656';
              this.link3 = '/lrnng/alctcr/alctcrDetailView.do?alctcrSn=138';
            } else {                            // A 등급
              this.grade = 'a';
              this.suggestType = 1;
              this.suggestTitle1 = '엔트리 기초 프로그래밍 1탄!';
              this.suggestTitle2 = 'Hello! EBS 소프트웨어! 스크래치 프로그래밍';
              this.suggestTitle3 = 'Hello! EBS 소프트웨어 알고리즘';
              this.link1 = '/lrnng/alctcr/alctcrDetailView.do?alctcrSn=141';
              this.link2 = '/lrnng/alctcr/alctcrDetailView.do?alctcrSn=358';
              this.link3 = '/lrnng/alctcr/alctcrDetailView.do?alctcrSn=162';
            }
          }
        })
        .finally(() => {
          this.isLoading = true
        })
    },
    checkSession () {
      const getCookie = this.getCookie('JSESSIONID');
      was
        .post(
          `${this.API_SERVER_URL}/manage/common/session/check`,
          { jsession_id: getCookie },
        )
        .then((response) => {
          if (response.status === 200) {
            if (response.data.code === "1000") {
              if (response.data.user_sn) {
                // 사용자 세션정보 Exist(사용자 통계정보 요청)
                this.getStudyAnalysis();

              } else {
                // 세션 데이터 없음
                this.isLoginPopup = true;
                this.showModal();
              }
            } else {
              // 세션 데이터 없음
              this.isLoginPopup = true;
              this.showModal();
            }
          }
        })
        .catch(e => {
          this.isLoginPopup = true;
          this.showModal();
          console.error(e)
        });
    }
  },
  computed: {
  }
}

</script>
<style lang="scss">
</style>
<style lang="less">
@import "../assets/styles/analysis/analysis";
</style>



// WEBPACK FOOTER //
// src/components/CodmosAnalysis.vue